var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgConnectIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56.463,
    height: 56.353,
    viewBox: "0 0 56.463 56.353",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#00b9ff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -0.5)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0.5)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(19.961)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M189.271,17.042a8.271,8.271,0,1,1,8.271-8.271A8.281,8.281,0,0,1,189.271,17.042Z",
    transform: "translate(-181 -0.5)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 34.844)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1.105,328.866a8.272,8.272,0,1,1,11.3,3.027,8.282,8.282,0,0,1-11.3-3.027Z",
    transform: "translate(0 -316.455)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(39.92 34.844)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M366.125,331.894a8.271,8.271,0,1,1,11.3-3.027A8.269,8.269,0,0,1,366.125,331.894Z",
    transform: "translate(-361.987 -316.455)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.457 11.277)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M34.654,117.783l-3.3-.181A24.906,24.906,0,0,1,42.534,98.223l1.816,2.766A21.6,21.6,0,0,0,34.654,117.783Z",
    transform: "translate(-31.352 -98.223)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(40.008 11.277)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M372.483,117.784a21.6,21.6,0,0,0-9.7-16.794l1.816-2.766A24.905,24.905,0,0,1,375.785,117.6Z",
    transform: "translate(-362.787 -98.224)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(17.046 51.243)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M165.759,466.236a24.572,24.572,0,0,1-11.185-2.657l1.493-2.953a21.638,21.638,0,0,0,19.385,0l1.493,2.953A24.571,24.571,0,0,1,165.759,466.236Z",
    transform: "translate(-154.574 -460.626)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnectIcon);
export default __webpack_public_path__ + "static/media/connect-icon.d773bb3fbe76d4148ce91677418afedf.svg";
export { ForwardRef as ReactComponent };